module.exports = __webpack_public_path__ + "static/img/Planificaciones_7_taxonomía de bloom@4x.d5fd0e60.png";